<template>
    <v-dialog
        v-model="dialog"
        width="700"
        persistent
    >
        <v-card>
            <v-card-title class="text-h5 secondary primary--text">
                Delete Student Records
            </v-card-title>

            <v-alert
                v-if="alert.display"
                dense
                text
                :type="alert.type"
                class="mt-2"
            >
                {{ alert.text }}
            </v-alert>

            <v-card-text class="mt-4">
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search Student"
                    single-line
                    hide-details
                    class="mb-4 pa-3"
                    clearable
                ></v-text-field>

                <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="students"
                    :loading="loading"
                    item-key="id"
                    show-select
                    fixed-header
                    height="50vh"
                    :search="search"
                >
                    
                </v-data-table>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    depressed
                    @click="close"
                    class="mr-3"
                >
                    Close
                </v-btn>
                <v-btn
                    color="primary"
                    class="mr-3"
                    @click="dialogConfirmDelete = true"
                >
                    Delete Selected
                </v-btn>
            </v-card-actions>
        </v-card>
        
        <v-overlay
            :value="overlay"
            :absolute="true"
        >
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
        </v-overlay>

        <v-dialog
            v-model="dialogConfirmDelete"
            max-width="450"
            peristent
        >
            <v-card>
                <v-card-title class="headline error--text">
                    <v-icon color="error" left>mdi-alert-circle</v-icon>
                    Confirm Delete
                </v-card-title>

                <v-card-text class="pt-2">
                    <p class="mb-2">
                        Are you sure you want to delete
                        <strong>{{ selected.length }} {{ selected.length === 1 ? 'record' : 'records' }}</strong>?
                    </p>
                    <v-alert type="warning" text dense class="mb-0">
                        This action is <strong>permanent and cannot be undone</strong>.
                    </v-alert>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn outlined color="grey" :disabled="loading" @click="dialogConfirmDelete = false">Cancel Delete</v-btn>
                    <v-btn color="error" depressed :loading="loading" @click="deleteSelected" >
                        Yes Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

           
    </v-dialog>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';

export default {
    props: {
        dialogOpen: Boolean,
    },

    created: function () {
        this.initialize();
    },

    data: function () {
        return {
            overlay: false,
            dialog: this.dialogOpen,
            headers:[
                { text: 'Student ID', value: 'id', width: '100' },
                { text: 'First Name', value: 'first_name', width: '100' },
                { text: 'Last Name', value: 'last_name', width: '100' },
                { text: 'Form Class', value: 'form_class_id', width: '100' },
            ],
            students: [],
            loading: false,
            selected: [],
            search: '',
            alert: {
                text: '',
                type: 'success',
                display: false,
            },
            dialogConfirmDelete: false,
        }
    },

    computed: {
       //
    },

    methods: {
        ...mapActions({
            getStudents: 'settings/getStudents',
            deleteStudents: 'settings/deleteStudents',
        }),

        ...mapMutations({
            setSelectedStudentIds: 'settings/setSelectedStudentIds',
        }),
        async initialize () {
            this.loading = true;
            this.overlay = true;
            try {
                const { data } = await this.getStudents();
                this.students = data;
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
            }
            finally {
                this.loading = false;
                this.overlay = false;
            }
        },

        async deleteSelected(){
            this.dialogConfirmDelete = false;
            this.overlay = true;
            const studentIds = this.selected.map(student => student.id);
            this.setSelectedStudentIds(studentIds);
            try {
                const { data } = await this.deleteStudents();
                this.alert.text = data.message;
                this.alert.type = 'success';
                this.initialize();
            } catch (error) {
                this.alert.text = error.response.data.message;
                this.alert.type = 'error';
                if(error.response) console.log(error.response);
                else console.log(error);
            }
            finally {
                this.overlay = false;
                this.alert.display = true;
            }
        },


        close () {
            this.$emit('dialog-close');
        },

       
    }
}
</script>